import { getCommunicationChartTeamIdForCrossTeamSpaceNode, getCommunicationChartTeamIdForExternalSpaceNode, getCommunicationChartTeamIdForInternalNode, isCommunicationChartCrossTeamSpaceNodeId, isCommunicationChartExternalSpaceNodeId, isCommunicationChartInternalMeetNodeId } from '@web/components/CommunicationNetworkGraph/core/communicationChart/constants';
import { isCommunicationChartOrgScope } from '@web/components/CommunicationNetworkGraph/core/communicationChart/types';
var linkTouchesInternalMeetNode = function (link) {
    return isCommunicationChartInternalMeetNodeId(link.sourceNodeId) ||
        isCommunicationChartInternalMeetNodeId(link.targetNodeId);
};
var linkTouchesCrossTeamSpaceNode = function (link) {
    return isCommunicationChartCrossTeamSpaceNodeId(link.sourceNodeId) ||
        isCommunicationChartCrossTeamSpaceNodeId(link.targetNodeId);
};
var linkTouchesExternalSpaceNode = function (link) {
    return isCommunicationChartExternalSpaceNodeId(link.sourceNodeId) ||
        isCommunicationChartExternalSpaceNodeId(link.targetNodeId);
};
export var usesCommunicationChartOrgTeamHubReveal = function (scope) { return isCommunicationChartOrgScope(scope); };
export var resolveCommunicationChartOrgTeamHubSatelliteNodeId = function (link) {
    if (isCommunicationChartInternalMeetNodeId(link.sourceNodeId)) {
        return link.sourceNodeId;
    }
    if (isCommunicationChartInternalMeetNodeId(link.targetNodeId)) {
        return link.targetNodeId;
    }
    if (isCommunicationChartCrossTeamSpaceNodeId(link.sourceNodeId)) {
        return link.sourceNodeId;
    }
    if (isCommunicationChartCrossTeamSpaceNodeId(link.targetNodeId)) {
        return link.targetNodeId;
    }
    if (isCommunicationChartExternalSpaceNodeId(link.sourceNodeId)) {
        return link.sourceNodeId;
    }
    if (isCommunicationChartExternalSpaceNodeId(link.targetNodeId)) {
        return link.targetNodeId;
    }
    return null;
};
export var resolveCommunicationChartOrgTeamHubEdgeTeamId = function (link) {
    if (linkTouchesInternalMeetNode(link)) {
        return isCommunicationChartInternalMeetNodeId(link.sourceNodeId)
            ? getCommunicationChartTeamIdForInternalNode(link.sourceNodeId)
            : getCommunicationChartTeamIdForInternalNode(link.targetNodeId);
    }
    if (linkTouchesCrossTeamSpaceNode(link)) {
        return isCommunicationChartCrossTeamSpaceNodeId(link.sourceNodeId)
            ? getCommunicationChartTeamIdForCrossTeamSpaceNode(link.sourceNodeId)
            : getCommunicationChartTeamIdForCrossTeamSpaceNode(link.targetNodeId);
    }
    if (linkTouchesExternalSpaceNode(link)) {
        return isCommunicationChartExternalSpaceNodeId(link.sourceNodeId)
            ? getCommunicationChartTeamIdForExternalSpaceNode(link.sourceNodeId)
            : getCommunicationChartTeamIdForExternalSpaceNode(link.targetNodeId);
    }
    return null;
};
export var resolveCommunicationChartOrgTeamHubSelectedTeamId = function (cy, selectedNodeId) {
    if (selectedNodeId === null) {
        return null;
    }
    var selectedNode = cy.getElementById(String(selectedNodeId));
    if (selectedNode.empty()) {
        return null;
    }
    if (selectedNode.hasClass('orgTeam')) {
        return selectedNodeId;
    }
    if (selectedNode.hasClass('teamHubSatellite')) {
        var hubTeamId = selectedNode.data('hubTeamId');
        return typeof hubTeamId === 'number' ? hubTeamId : null;
    }
    return null;
};
/** Selection pins hubs; hover adds another team's hubs without hiding the selected team. */
export var mergeCommunicationChartOrgTeamHubRevealTeamIds = function (selectedTeamId, hoveredTeamId, pinnedHubTeamId) {
    if (pinnedHubTeamId === void 0) { pinnedHubTeamId = null; }
    var revealedTeamIds = new Set();
    if (selectedTeamId !== null) {
        revealedTeamIds.add(selectedTeamId);
    }
    if (hoveredTeamId !== null) {
        revealedTeamIds.add(hoveredTeamId);
    }
    if (pinnedHubTeamId !== null) {
        revealedTeamIds.add(pinnedHubTeamId);
    }
    return Array.from(revealedTeamIds);
};
export var resolveCommunicationChartOrgTeamHubRevealTeamIds = function (cy, selectedNodeId, hoveredTeamId, pinnedHubTeamId) {
    if (pinnedHubTeamId === void 0) { pinnedHubTeamId = null; }
    return mergeCommunicationChartOrgTeamHubRevealTeamIds(resolveCommunicationChartOrgTeamHubSelectedTeamId(cy, selectedNodeId), hoveredTeamId, pinnedHubTeamId);
};
export var applyCommunicationChartOrgTeamHubVisibility = function (cy, revealedTeamIds) {
    var revealedTeamIdSet = new Set(revealedTeamIds);
    cy.batch(function () {
        cy.nodes('.teamHubSatellite').forEach(function (node) {
            var hubTeamId = node.data('hubTeamId');
            var shouldShow = typeof hubTeamId === 'number' && revealedTeamIdSet.has(hubTeamId);
            node.toggleClass('hubHidden', !shouldShow);
            if (shouldShow) {
                node.removeStyle('display');
                node.removeStyle('events');
            }
            else {
                node.style('display', 'none');
                node.style('events', 'no');
            }
        });
        cy.edges('.teamHubEdge').forEach(function (edge) {
            var hubTeamId = edge.data('hubTeamId');
            var shouldShow = typeof hubTeamId === 'number' && revealedTeamIdSet.has(hubTeamId);
            edge.toggleClass('hubHidden', !shouldShow);
            if (shouldShow) {
                edge.removeStyle('display');
                edge.removeStyle('opacity');
                edge.removeStyle('events');
            }
            else {
                edge.style('display', 'none');
                edge.style('events', 'no');
            }
        });
    });
};
